import { createMemoryHistory, createRouter } from 'vue-router';
import RouteNames from './names.routes';
// Views
import {
  AssistantType,
  ReviewingAssistantType
} from '@/models/assistant-types';
import { RouterValidationUtils } from '@/utils/router.utils';
import ChatHistoryView from '@/views/chat_history/ChatHistoryView.vue';
import DocumentReviewing from '@/views/doc_reviewing/DocumentReviewing.vue';
import FranceAuth from '@/views/france_auth/FranceAuth.vue';
import HomeView from '@/views/HomeView.vue';
import LegalAssistantView from '@/views/legal_assistant/LegalAssistantView.vue';
import SpainAuth from '@/views/spain_auth/SpainAuth.vue';
import UserSettingsView from '@/views/user_settings/UserSettingsView.vue';
import WelcomeScreenView from '@/views/welcome_screen/WelcomeScreenView.vue';

const routes = [
  {
    path: '/',
    name: RouteNames.Welcome,
    component: WelcomeScreenView
  },
  {
    path: '/home',
    name: RouteNames.Home,
    component: HomeView
  },
  {
    path: '/legal-assistant',
    name: RouteNames.LegalAssistant,
    component: LegalAssistantView
  },
  {
    path: '/legal-assistant/history',
    name: RouteNames.LegalHistory,
    component: ChatHistoryView,
    props: (route: {
      params: { conversationId: string | undefined };
      query: { conversationId: string | undefined };
    }) => ({
      assistant: AssistantType.LegalAssistant,
      conversationId: route.params.conversationId || route.query.conversationId
    })
  },
  {
    path: '/france-auth',
    name: RouteNames.FranceAuth,
    component: FranceAuth
  },
  {
    path: '/user-settings',
    name: RouteNames.UserSettings,
    component: UserSettingsView
  },
  {
    path: '/doc-review',
    name: RouteNames.Reviewing,
    component: DocumentReviewing,
    beforeEnter: async () => {
      const { DocumentValidationUtils } = await import(
        '@/utils/document-validation.utils'
      );
      const i18n = (await import('@/configuration/i18n/i18n.configuration'))
        .default;

      const { t } = i18n.global;

      return RouterValidationUtils.validateRule(
        () => DocumentValidationUtils.validateReviewRequirements(t),
        RouteNames.Reviewing
      );
    }
  },
  {
    path: '/doc-review/history',
    name: RouteNames.ReviewingHistory,
    component: ChatHistoryView,
    props: (route: {
      params: { conversationId: string | undefined };
      query: { conversationId: string | undefined };
    }) => ({
      assistant: ReviewingAssistantType.DocumentReviewingAssistant,
      conversationId: route.params.conversationId || route.query.conversationId
    })
  },
  {
    path: '/spain-auth',
    name: RouteNames.SpainAuth,
    component: SpainAuth
  }
];

const router = createRouter({
  history: createMemoryHistory(),
  routes
});

export default router;
